import React from "react"
import styles from './Checkbox.module.scss';
import classNames from "classnames";
import { InputError } from "../InputError";
import { ConditionalRender } from "@/components/ConditionalRender";

interface CheckboxProps {
  input: React.InputHTMLAttributes<HTMLInputElement>;
  hidden?: React.InputHTMLAttributes<HTMLInputElement>;
  label: React.LabelHTMLAttributes<HTMLLabelElement> & { text: string | React.ReactNode };
  error?: string;
  className?: string;
}

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const {
    className,
    input,
    label,
    error,
    hidden,
  } = props;

  const { text: labelText, ...labelRest } = label;

  return (
    <div className={classNames(styles.Checkbox, className)}>
      <ConditionalRender condition={hidden}>
        <input
          type="hidden"
          {...hidden}
        />
      </ConditionalRender>

      <div className={styles.container}>
        <input
          {...input}
          className={classNames(input.className, styles.error)}
        />

        <label
          {...labelRest}
          dangerouslySetInnerHTML={{ __html: labelText }}
        />
      </div>

      <ConditionalRender condition={error}>
        <InputError text={error} />
      </ConditionalRender>
    </div>
  )
}